// Framer Motion Animation Variants

// 1. FADE IN (Cards, Text)
export const fadeIn = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: 'easeOut' },
};

// 2. FADE IN UP (Hero elements)
export const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
};

// 3. SLIDE IN FROM LEFT (Features)
export const slideInLeft = {
  initial: { opacity: 0, x: -50 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
};

// 4. SLIDE IN FROM RIGHT
export const slideInRight = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
};

// 5. SCALE IN (Buttons, Icons)
export const scaleIn = {
  initial: { scale: 0.8, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  transition: { duration: 0.4, ease: 'easeOut' },
};

// 6. STAGGER CONTAINER (Lists, Grids)
export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

// 7. STAGGER ITEM (Child elements)
export const staggerItem = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

// 8. HOVER LIFT (Cards)
export const hoverLift = {
  y: -8,
  scale: 1.02,
  transition: { duration: 0.2, ease: 'easeInOut' },
};

// 9. HOVER SCALE (Buttons)
export const hoverScale = {
  scale: 1.05,
  transition: { duration: 0.2, ease: 'easeInOut' },
};

// 10. PULSE (Attention grabbers)
export const pulse = {
  scale: [1, 1.05, 1],
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};

// 11. ROTATE (Icons on hover)
export const rotate = {
  rotate: 360,
  transition: { duration: 0.5, ease: 'easeInOut' },
};

// 12. SLIDE IN BOTTOM (Modals, Drawers)
export const slideInBottom = {
  initial: { opacity: 0, y: 100 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 100 },
  transition: { duration: 0.3, ease: 'easeOut' },
};

// 13. FADE (Simple fade for backgrounds)
export const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 },
};

// 14. VIEWPORT CONFIG (For scroll animations)
export const viewportConfig = {
  once: true,
  amount: 0.3,
  margin: '0px 0px -100px 0px',
};

// 15. COUNTER ANIMATION (Stats)
export const counterAnimation = (target) => ({
  initial: { count: 0 },
  animate: { count: target },
  transition: { duration: 2, ease: 'easeOut' },
});

// 16. GRADIENT SHIFT (Backgrounds)
export const gradientShift = {
  animate: {
    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
    transition: {
      duration: 5,
      repeat: Infinity,
      ease: 'linear',
    },
  },
};

// 17. DRAW LINE (SVG animations)
export const drawLine = {
  initial: { pathLength: 0, opacity: 0 },
  animate: { pathLength: 1, opacity: 1 },
  transition: { duration: 1.5, ease: 'easeInOut' },
};

// 18. PAGE TRANSITION
export const pageTransition = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 20 },
  transition: { duration: 0.4, ease: 'easeInOut' },
};

// Helper function to create custom delays
export const withDelay = (animation, delay) => ({
  ...animation,
  transition: { ...animation.transition, delay },
});

// Helper function for responsive reduced motion
export const getAnimationProps = (animation, prefersReducedMotion = false) => {
  if (prefersReducedMotion) {
    return {
      initial: animation.animate,
      animate: animation.animate,
    };
  }
  return animation;
};
